let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iILx7")).then(() => parcelRequire('aIi75'));